import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";
import { variablesButton } from "@/shared/Constants";

/* //BACKGROUND VIDEOS y FOTOS VISUALES */
const linearGradientDesktop = `
  background: linear-gradient(
  to bottom,
  transparent 0,
  transparent -30%,
  rgba(25, 25, 25, 0.7),
  #151e24
  );
`;
const linearGradientMobile = `
background: none;
`;
const linearGradientTop = `
background: linear-gradient( 
  to top, 
  transparent 0, 
  transparent 26%, 
  rgba(25,25,25,0.7), #151e24 );
  bottom:inherit;
`;

const BackgroundVisual = `
    ${linearGradientDesktop};
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    content: "";
    position: absolute;
    height: 75%;
    width: 100%;
    bottom:0;
  z-index:1;
  ${breakpoints.phone} {
    width: 100%;
    ${linearGradientMobile};
  }
`;
/* //FIN BACKGROUND VIDEOS VISUALES */

export const VisualArticle = styled.article`
  position: relative;

  &.visual-article-streaming-twoxone {
    .modulo2x1 {
      height: 315px;
      @media (max-width: 1367px) {
        display: flex;
        flex-direction: column-reverse;
        justify-content: flex-end;
        .bottomSummary {
          display: none;
        }
      }
      ${breakpoints.phone} {
        width: 100%;
        height: 100%;
      }
    }
    .mt {
      display: none;
      @media (max-width: 1367px) {
        position: relative;
        display: block;
        margin: 10px 0;
        left: unset !important;
        bottom: unset;
        width: 100%;
        .title {
          font-size: 21px !important;
          line-height: 24px !important;
          color: black;
          text-shadow: none;
        }
      }
      ${breakpoints.phone} {
        .title {
          font-size: 22px !important;
          line-height: 25px !important;
        }
      }
    }
  }
  > div {
    position: relative;
    ${breakpoints.phone} {
      display: flex;
      width: 100%;
      flex-direction: column-reverse;
      width: 100%;
    }
  }
  picture {
    display: block;
    position: relative;
    height: auto;
    object-fit: cover;
    .img {
      height: 100%;
      object-fit: cover;
    }
    ${breakpoints.phone} {
      width: 100%;
      /* min-height: 340px; */
    }
    &:after {
      ${BackgroundVisual};
    }
    &.app-square,
    &.app-vertical,
    &.app-full {
      :after {
        background: linear-gradient(
          to bottom,
          transparent 0,
          transparent -30%,
          rgba(25, 25, 25, 0.7),
          #151e24
        );
      }
    }
    &.title-top {
      &:after {
        ${linearGradientTop};
      }
    }
  }
  .contentVideo {
    /* display: block;
    position: relative; */
    height: inherit;
    > div {
      height: inherit !important;
    }
    .jwplayer.jw-stretch-uniform .jw-media video {
      object-fit: cover !important;
    }
    &:after {
      ${BackgroundVisual};
    }
    &.title-top {
      &:after {
        ${linearGradientTop};
      }
    }
  }
  .mt {
    position: absolute;
    left: 35px;
    bottom: 35px;
    display: flex;
    flex-direction: column;
    z-index: 2;
    width: 80%;
    ${breakpoints.phone} {
      position: inherit;
      margin: 15px 0;
      width: 100%;
      left: inherit;
      bottom: inherit;
    }
    h2.title {
      ${Font.clarinVarSub2Bold};
      color: ${Color.white};
      text-shadow: 0 0 9px #101010;
      order: 2;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
      ${breakpoints.phone} {
        text-shadow: inherit;
        color: ${Color.black};
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            color: ${ColorDark.textLight};
          }
        }
      }
    }
    .volanta {
      ${Font.clarinVarSub2Regular};
      color: #fff;
      order: 1;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
      ${breakpoints.phone} {
        text-shadow: inherit;
        color: ${Color.mainColor};
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            color: ${ColorDark.textLight};
          }
        }
      }
    }
    .bajada {
      ${Font.sansRegular};
    }
    .data-txt {
      display: flex;
      align-items: center;
      gap: 6px;
      order: 3;
      > p.name {
        font-size: 11.5px;
        line-height: 11px;
        ${Font.sansRegular};
        color: ${Color.white};
        text-transform: uppercase;
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            color: ${ColorDark.textLight};
          }
        }
        ${breakpoints.phone} {
          text-shadow: inherit;
          color: ${Color.black};
          ${breakpoints.darkMode} {
            [data-theme="dark"] & {
              color: ${ColorDark.textLight};
            }
          }
        }
      }
      .ifPaywallPipe {
        &::before {
          color: ${Color.white};
        }
      }
      .icon-paywall-box {
        p {
          color: ${Color.white};
          ${breakpoints.darkMode} {
            [data-theme="dark"] & {
              color: ${ColorDark.textLight};
            }
          }
        }
      }
    }
    &.title-top {
      bottom: inherit;
      top: 35px;
      ${breakpoints.phone} {
        top: inherit;
      }
    }
    &.title-bottom {
      bottom: 35px;
      top: inherit;
    }
  }
`;
